import classNames from 'classnames'

import { CommonNoticeIcon } from '@local/assets/icons'
import WeatherIcon from '@local/assets/images/weather'

export type NowWeather = {
  region: { short: string }
  weatherForecast: {
    decimalTemperature: number
    weatherText: string
    weatherCode: number
  } | null
  airForecast: {
    pm10: { legend: string; textColorCode: string | null }
  } | null
} | null

import Image from '@web/components/Image'

import styles from './DailyWeather.module.scss'

// textColorCode 에 따른 텍스트 참고용
// eslint-disable-next-line no-unused-vars
const TextColorCodeToAirQuality = {
  '#2571B3': { status: '좋음' },
  '#0D7A1F': { status: '보통' },
  '#9F6A1C': { status: '나쁨' },
  '#B32D2D': { status: '매우 나쁨' },
}

interface AirProps {
  text: string
  textColorCode: string
}

type WeatherKey = keyof typeof WeatherIcon

interface Props {
  weather?: NowWeather
}
function AirQuality({ text, textColorCode }: AirProps) {
  return (
    <strong className={classNames(styles.status)} style={{ color: textColorCode }}>
      {text}
    </strong>
  )
}

export default function DailyWeather({ weather }: Props) {
  const { weatherForecast, airForecast, region } = weather || {}
  const weatherIconCode = weatherForecast?.weatherCode || 1
  const weatherIconSrc = WeatherIcon[weatherIconCode as WeatherKey]
  return (
    <div className={styles.weather_area}>
      {weatherForecast && airForecast && region ? (
        <>
          <div className={styles.local_area}>
            <Image
              className={styles.img}
              src={weatherIconSrc}
              width="20"
              height="20"
              alt={weatherForecast.weatherText}
            />
            <span className={styles.name}>{region.short}</span>
            <strong className={styles.temperature}>{`${weatherForecast.decimalTemperature}°C`}</strong>
          </div>
          <div className={styles.info_area}>
            <span className={styles.info}>{weatherForecast.weatherText}</span>
            <span className={styles.dust}>
              {'미세 '}
              {airForecast.pm10?.textColorCode && (
                <AirQuality text={airForecast.pm10?.legend} textColorCode={airForecast.pm10.textColorCode} />
              )}
            </span>
          </div>
        </>
      ) : (
        <>
          <div className={styles.error_area}>
            <CommonNoticeIcon className={styles.icon} aria-hidden="true" />
            지금은 날씨정보를 확인할 수 없어요.
          </div>
        </>
      )}
    </div>
  )
}
